import React from 'react';
import { Clock } from 'lucide-react';
import { ChatCircleText, CalendarX, EnvelopeOpen, PhoneCall, ShieldCheck } from '@phosphor-icons/react';
import AppIcon from '../AppIcon';

const ROWS = [
  { icon: ChatCircleText, tone: 'sky', hours: 6, title: 'Chases RSVPs for you', body: 'Friendly reminder texts and emails go out on a schedule until every guest replies.' },
  { icon: CalendarX, tone: 'coral', hours: 2, title: 'Auto-declines late replies', body: 'When your reply-by date passes, stragglers are marked “not coming”, so your caterer count is final on time.' },
  { icon: EnvelopeOpen, tone: 'rose', hours: 3, title: 'Sends Mom the RSVP digest', body: 'Daily or weekly headcount reports to your inner circle. No more “any updates?” texts.' },
  { icon: PhoneCall, tone: 'lavender', hours: 8, title: 'An AI answers your wedding phone', body: 'Parking, dress code, hotel block: guests call or text and get answers 24/7. (Concierge)' },
  { icon: ShieldCheck, tone: 'sage', hours: null, title: 'Collects texting consent properly', body: 'Opt-ins, STOP handling and an audit trail are built in, so your guest texts stay on the right side of carrier rules.' },
];

const TOTAL = ROWS.reduce((n, r) => n + (r.hours || 0), 0);

export const FreeToolsGap = () => (
  <div data-testid="free-tools-gap" className="mt-20 grid lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] gap-10 items-start">
    <div className="lg:sticky lg:top-24">
      <p className="section-eyebrow">What free tools don't do</p>
      <h3 className="font-serif text-3xl lg:text-4xl mt-3 text-[#2A2A2A] leading-tight">Get about {TOTAL} hours of wedding admin back.</h3>
      <p className="mt-4 text-[#4A4A4A] text-sm leading-relaxed max-w-md">
        Free wedding sites give you a website and an RSVP form, and then you do the chasing. We do the follow-up for you.
      </p>
      <div data-testid="free-tools-gap-math" className="mt-6 inline-flex items-center gap-3 rounded-2xl bg-[#2A1F1B] text-[#FBF7F2] px-5 py-4">
        <Clock className="w-5 h-5 text-[#EFC9B0]" />
        <p className="text-sm">On Beloved, that's under <strong className="text-[#EFC9B0]">${(149 / TOTAL).toFixed(0)}/hour</strong> for your time, and never more than $149 total.</p>
      </div>
      <p className="mt-3 text-[10px] text-[#9A8A7E]">Estimated hours for a typical 120-guest wedding.</p>
    </div>
    <ul className="space-y-3">
      {ROWS.map(({ icon, tone, hours, title, body }, i) => (
        <li key={title} data-testid={`free-tools-gap-row-${i}`} className="group soft-card rounded-2xl p-5 flex items-start gap-4 transition-transform duration-300 hover:-translate-y-0.5">
          <AppIcon icon={icon} tone={tone} size="md" interactive reveal delay={i * 90} />
          <div className="flex-1 min-w-0">
            <div className="flex items-baseline justify-between gap-3">
              <p className="font-medium text-[#2A2A2A]">{title}</p>
              {hours && <span className="text-xs text-[#7B2C3B] whitespace-nowrap">~{hours} hrs saved</span>}
            </div>
            <p className="text-sm text-[#6A6A6A] mt-1">{body}</p>
          </div>
        </li>
      ))}
    </ul>
  </div>
);

export default FreeToolsGap;
